import { FormikProps } from 'formik/dist/types';
import * as Yup from 'yup';
import { ErrorWord, AccountEstablishRequestParam, EstablishPageType } from '../common';

/*--------------
  信託同意
  --------------*/

//入力値の型
export type ConsentTrustType = {
  // 分配金計算書の提供方法についての同意
  distributionStatementAgreement: boolean;
};
//Formik用の型
export type ConsentTrustFormikType = FormikProps<ConsentTrustType>;

//Formikに渡す初期値
export const consentTrustinitialValues = (param: ConsentTrustType) => {
  return {
    ...param,
    distributionStatementAgreement: param.distributionStatementAgreement ?? false,
  };
};

//バリデーション
export const consentTrustValidation = Yup.object().shape({
  distributionStatementAgreement: Yup.bool().oneOf([true], ErrorWord.UABLE_OPEN_ACCOUNT_TYPE5),
});

//Formikのサブミットメソッド
export const consentTrustOnSubmit = (
  param: AccountEstablishRequestParam,
  setNowEstablishPageType: (navType: EstablishPageType) => void,
  add: (data: AccountEstablishRequestParam) => void,
) => {
  return (values: ConsentTrustType) => {
    add({
      ...param,
      distributionStatementAgreement: values.distributionStatementAgreement,
    });
    setNowEstablishPageType(EstablishPageType.CustomerInfo);
  };
};
